const FIXED_PRICES = 'pricesFixedForm';
const CATEGORY_PRICES = 'pricesCategoryForm';
const DAILY_PRICES = 'pricesDailyForm';
const FUTURE_PRICES = 'futurePricesForm';
const ACTIVITY_FUTURE_PRICES = 'activityFuturePricesForm'

export { FIXED_PRICES, CATEGORY_PRICES, DAILY_PRICES, FUTURE_PRICES,ACTIVITY_FUTURE_PRICES };
